import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { useT } from "../../lib/i18n";
import { track } from "../../lib/track";

const KEY = "kouoh-exit-shown";
const SKIP = [/^\/admin/, /^\/demande\/confirmation/, /^\/espace-client/];

export function ExitIntent() {
  const { t } = useT();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ email: "", phone: "", name: "" });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (SKIP.some((r) => r.test(pathname)) || localStorage.getItem(KEY)) return;
    let timer;
    const show = () => { if (localStorage.getItem(KEY)) return; localStorage.setItem(KEY, String(Date.now())); setOpen(true); track("exit_intent_shown", { path: pathname }); };
    const onLeave = (e) => { if (e.clientY <= 0) show(); };
    timer = setTimeout(show, 45000);
    document.addEventListener("mouseout", onLeave);
    return () => { clearTimeout(timer); document.removeEventListener("mouseout", onLeave); };
  }, [pathname]);

  if (!open) return null;
  const submit = async (e) => {
    e.preventDefault();
    if (!f.email && !f.phone) { setErr(t("Un email ou un numéro, au choix.")); return; }
    try { await api.post("/public/leads", { ...f, page: pathname }); setDone(true); track("exit_intent_lead", { path: pathname }); } catch { setErr(t("Impossible d'envoyer pour l'instant.")); }
  };
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[90] bg-black/40 flex items-end sm:items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="exit-intent">
      <div className="bg-[#FBF9F5] w-full max-w-md p-6 sm:p-8 shadow-xl relative" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={() => setOpen(false)} aria-label={t("Fermer")} className="absolute right-3 top-3 p-1" data-testid="exit-intent-close"><X size={18} /></button>
        {done ? (
          <div data-testid="exit-intent-done"><p className="k-eyebrow">{t("C'est noté")}</p><p className="font-display text-2xl mt-2">{t("On vous écrit dans la journée.")}</p><p className="text-sm text-[#57534E] mt-2">{t("Un conseiller de l'atelier vous contacte pour comprendre votre projet. Sans engagement.")}</p></div>
        ) : (
          <form onSubmit={submit} className="grid gap-3">
            <p className="k-eyebrow">{t("Un projet en tête ?")}</p>
            <p className="font-display text-2xl leading-tight">{t("Laissez-nous un moyen de vous joindre, on s'occupe du reste.")}</p>
            <p className="text-sm text-[#57534E]">{t("Un conseiller vous rappelle ou vous écrit sous 24 h pour vous aider à choisir. Gratuit, sans engagement.")}</p>
            <input className="k-input" placeholder={t("Prénom (optionnel)")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="exit-intent-name" />
            <input className="k-input" type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="exit-intent-email" />
            <input className="k-input" type="tel" placeholder={t("ou téléphone")} value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="exit-intent-phone" />
            {err && <p className="text-xs text-[#A84C2A]" role="alert">{err}</p>}
            <button type="submit" className="k-btn justify-center" data-testid="exit-intent-submit">{t("Être recontacté")} <ArrowRight size={16} /></button>
          </form>
        )}
      </div>
    </div>, document.body);
}
